import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  seoContentIcon,
  adCopyContentIcon,
  socialMediaContentIcon,
  personalBrandingContentIcon,
  podcastContentICon,
} from "../../../../assets/icons/serviceIcon/index";
import WebsiteContentWork from "./WebsiteContentWork";
import { useEffect } from "react";

const items = [
  {
    name: "Landing Pages",
    text: "We write landing pages that actually land. From the headline to the final button, every line is crafted to spark action, not confusion.",
  },
  {
    name: "Service Pages",
    text: "Instead of long explanations that no one reads, we break down your offers into clear, engaging copy that sounds like you and sells for you.",
  },
  {
    name: "Brand Storytelling",
    text: "Your journey matters. We turn your backstory, beliefs and vibe into a brand story that feels human and builds trust.",
  },
];

const otherService = [
  {
    icon: seoContentIcon,
    name: "Seo Blog Writing",
    des: "Blog posts that teach, tell stories and rank on Google",
    path: "/seo-blog-writing",
  },
  {
    icon: adCopyContentIcon,
    name: "Ad Copy & Sales Funnels",
    des: 'Clear words that guide people from curiosity to clicking "yes"',
    path: "/ad-copy-and-sale-funnels",
  },
  {
    icon: socialMediaContentIcon,
    name: "Social Media Strategy",
    des: "Plan smart, scroll-worthy posts that actually speak to your audience",
    path: "/social-media-strategy",
  },
  {
    icon: personalBrandingContentIcon,
    name: "Personal Branding Content",
    des: "Bring your voice to life across everything your audience sees",
    path: "/personal-branding-content",
  },
  {
    icon: podcastContentICon,
    name: "Podcast Scripting & Editing",
    des: "Turn your ideas into podcasts that engage with your audience",
    path: "/podcast-scripting-and-editing",
  },
];
const WebsiteContent = () => {

    useEffect(() => {
      // Set Page Title
      document.title = "Website Content Writing Services | TechQilla";
  
      // --- Description ---
      let metaDescription = document.querySelector<HTMLMetaElement>(
        "meta[name='description']",
      );
      if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute(
        "content",
        "Professional website content writing services to boost engagement, SEO rankings, and conversions. TechQilla crafts content that drives results.",
      );
  
      // --- Keywords ---
      let metaKeywords = document.querySelector<HTMLMetaElement>(
        "meta[name='keywords']",
      );
      if (!metaKeywords) {
        metaKeywords = document.createElement("meta");
        metaKeywords.name = "keywords";
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.setAttribute("content", "Website Content Writing Services");
      // --- Canonical ---
      let linkTag = document.querySelector<HTMLLinkElement>(
        "link[rel='canonical']",
      );
      if (!linkTag) {
        linkTag = document.createElement("link");
        linkTag.rel = "canonical";
        document.head.appendChild(linkTag);
      }
      linkTag.setAttribute("href", "https://www.techqilla.com/website-content");
    }, []);
  
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Content"
        description="Your website is more than just a digital address. It’s the place where people decide if they trust you, like you, and want to buy from you. We help you get those words right, so you don’t just attract visitors, you keep them hooked."
        heading="Website"
      />
      <NewCommonServiceForm title="Website Content" items={items} />
      <WebsiteContentWork />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default WebsiteContent;
